// extracted by mini-css-extract-plugin
export default {"root":"uF44qP","root2":"zXz3Tz","input-area":"qGFEXj","inputArea":"qGFEXj"};